// extracted by mini-css-extract-plugin
export var closeButton = "_l3-1";
export var closeX = "_l3-3";
export var container = "_l3-0";
export var image = "_l3-2";